<template>
  <div class="BusinessAmount">
    <BarChartDisplay
      :title="$t('business.quantity-sector')"
      :options="sectorsData"
      :series="series"
    />
  </div>
</template>

<script>
import { BarChartDisplay } from '@/components';
import { getAmountBusiness } from '@/api';

export default {
  name: 'BusinessAmount',
  data() {
    return {
      sectorsData: {
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          bar: {
            horizontal: true,
            columnWidth: '100%',
            barHeight: '70%',
            distributed: true,
          },
        },
      },
      series: [],
    };
  },
  components: {
    BarChartDisplay,
  },
  created() {
    getAmountBusiness().then(
      data => {
        this.series = data;
      },
      err => {
        console.log('Fetch Error: ', err);
      }
    );
  },
};
</script>

<style lang="scss">
.BusinessAmount {
  width: 35%;
  margin-right: rem(10);
}
</style>
